module.exports = __webpack_public_path__ + "img/img-otp-04.a6bd4a4c.png";